export const environment = process.env.REACT_APP_ENVIRONMENT_VARIABLE || 'production' ;
console.log({environment})
export default environment;